"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
exports.default = ({ colour = "currentColor" }) => {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("g", { clipPath: "url(#a)" },
            react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7 31.643c0 1.161 1.348 1.764 2.207 1.048l.004-.003c1.452-1.211 2.88-2.423 4.182-3.688h14.88C30.883 29 33 26.542 33 23.925V11.739A4.733 4.733 0 0 0 28.273 7H11.727A4.733 4.733 0 0 0 7 11.74v19.903ZM10 28l2.417-2H28.5c.653 0 1.5-.846 1.5-1.5v-13c0-.654-.847-1.5-1.5-1.5h-17c-.653 0-1.5.846-1.5 1.5V28Z", fill: colour })),
        react_1.default.createElement("defs", null,
            react_1.default.createElement("clipPath", { id: "a" },
                react_1.default.createElement("path", { fill: "#fff", transform: "translate(7 7)", d: "M0 0h26v26H0z" })))));
};
//# sourceMappingURL=MessageV2.js.map